import React from 'react'
import { connect } from 'react-redux'
import { Tabs, Badge } from 'antd-mobile'
// import { StickyContainer, Sticky } from 'react-sticky'
import { Header, Wrapper, Container } from '../../../components_renew/Layout'
import { OrderListItem } from '../../../components_renew/Mall/OrderListItem'
import { componentUpdateWithToast } from '../../../components_renew/HOC'
import { requestOrderListData, setOrderListIndex } from '../../../actions/mallAction'
import { postMessage } from '../../../utils'
import { withTranslation } from 'react-i18next'

// let renderTabBar = props => (<Sticky>
//   {({ style }) => <div style={{ ...style, zIndex: 1 }}><Tabs.DefaultTabBar {...props} /></div>}
// </Sticky>)

@withTranslation()
@connect((state, props) => {
  const {t} = props
  let { common, mallOrderList } = state
  let { data, index, refresh } = mallOrderList
  let { loading, errorMessage } = common
  return {
    loading,
    errorMessage,
    data,
    refresh,
    index,
    tabs: [
      { key: 'all', title: t('order.tab_1') },
      { key: 'payment', title: <Badge content={data['payment'].length>0?data['payment'].length:null}>{t('order.tab_2')}</Badge> },
      { key: 'delivery', title: <Badge content={data['delivery'].length>0?data['delivery'].length:null}>{t('order.tab_3')}</Badge> },
      { key: 'sign', title: <Badge content={data['sign'].length>0?data['sign'].length:null}>{t('order.tab_4')}</Badge> },
      { key: 'complete', title: t('order.tab_5') }
    ]
  }
})
@componentUpdateWithToast
class OrderList extends React.Component {

  componentDidMount () {
    const { t } = this.props
    if (!window.axios.getToken()) {
      window.toast.info(t('common.login_info_1'), 1, () => {
        // window.postMessage(JSON.stringify({ type: 'loginRequest' }), '*')
        postMessage({ type: window.POST_TYPE.LOGIN_REQUEST })
      })
    } else {
      let { data, refresh } = this.props
      if (refresh || !(data['all'].length > 0)) {
        this.props.dispatch(requestOrderListData())
      }
    }
  }

  render () {
    let { index, data, tabs, t } = this.props
    // let { all, payment, delivery, sign, complete } = data
    return <Container>
      <Header>
        {t('order.title')}
      </Header>
      <div className={'sticky top-0'} style={{backgroundColor: 'var(--adm-color-background)'}}>
        <Tabs
          // swipeable无法在滑动的时候提供hook
          swipeable={false}
          activeKey={index}
          onChange={this.onTabClick}
        >
          {tabs.map(tab => (<Tabs.Tab
            key={tab.key}
            title={tab.title}
          >
            {/*{data[tab.key].map(data => <OrderListItem {...data} key={data['orderId']}*/}
            {/*                                          onOrderClick={this.onOrderClick}/>)}*/}
          </Tabs.Tab>))}
        </Tabs>
      </div>
      <Wrapper flex>
        {/*todo 这里的sticky不生效,文档流有问题,很乱*/}
        <div>
          {data[index].map(data => <OrderListItem {...data} key={data['orderId']}
                                                  onOrderClick={this.onOrderClick} />)}
        </div>
      </Wrapper>
    </Container>
  }

  onTabClick = (key) => {

    if (key === this.props.index) return
    this.props.dispatch(setOrderListIndex(key))

    // todo 这个函数要改
    // if (tab['key'] === this.props.index) return
    // this.props.dispatch(setOrderListIndex(tab['key']))
  }

  onOrderClick = (clickType, orderId) => {
    // todo 缺一个确认收货? 7/14/2020
    console.log(clickType)
    if (clickType === 'pay') {
      this.props.history.push(`${window.PATH.MALL_ORDER_PAY}/${orderId}`)
    }

  }
}

export { OrderList }
